import { Link } from "react-router-dom";
import { AiOutlineMail, AiOutlineInfoCircle } from "react-icons/ai";

// eslint-disable-next-line import/no-anonymous-default-export
export default function () {
  return (
    <>
      <footer id="contactus" className="bg-secondary flex justify-center items-center gap-x-4 py-5 text-center text-white text-md text-[16px] font-normal">
        <Link to="/terms-and-condition" className="flex gap-2 items-center">
          <AiOutlineInfoCircle className="text-2xl" /> Terms and Conditions
        </Link>
        <span className="block bg-white w-[2px] h-full py-5 "></span>
        <div className="flex gap-2 items-center">
          <AiOutlineMail className="text-2xl" /> deepfakeaudio24@gmail.com
        </div>
        {/* <a href="mailto:admin@gmail.com" className="flex gap-2 items-center">
          <AiOutlineMail className="text-2xl" />
          admin@gmail.com
        </a> */}
      </footer>
    </>
  );
}
